/**
 * Petites préférences d'interface persistées dans `localStorage`.
 * Tout est gardé par try/catch : mode privé, cookies bloqués ou quota plein ne
 * doivent jamais casser l'écran (même contrat que `src/core/storage.ts`).
 */

export function readPref(key: string): string | null {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writePref(key: string, value: string): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(key, value);
  } catch {
    /* stockage indisponible : la préférence ne survivra pas au rechargement */
  }
}

export function removePref(key: string): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Lit une valeur JSON persistée. Renvoie `null` si absente ou illisible. */
export function readJsonPref<T>(key: string): T | null {
  const raw = readPref(key);
  if (!raw) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    return parsed as T;
  } catch {
    return null;
  }
}

export function writeJsonPref(key: string, value: unknown): void {
  try {
    writePref(key, JSON.stringify(value));
  } catch {
    /* valeur non sérialisable : on n'écrit rien */
  }
}
